import {
  FinnishProductDetailsExtendedModel,
  FinnishProductDetailsModel,
} from "../shared/services/finnish-product-details.model";

export class MySelectElectricityProductModel extends FinnishProductDetailsModel {
  /**
   * Whether the product is loading or not
   */
  loading?: boolean;
  /**
   * Whether the product loading completed with error or not
   */
  error?: boolean;
  /**
   * Whether the product has been selected or not
   */
  selected?: boolean;
}

export class MySelectElectricityProductExtendedModel extends FinnishProductDetailsExtendedModel {
  /**
   * Whether the product is loading or not
   */
  loading?: boolean;
  /**
   * Whether the product loading completed with error or not
   */
  error?: boolean;
  /**
   * Whether the product has been selected or not
   */
  selected?: boolean;
}
